<script>

    import {onMount} from "svelte";
    import {GET, POST} from "../../components/communication.js";
    import {
        userFeatures,
        userData,
        flashSuccessMessage,
    } from "../../components/stores.js";
    import {
        encodeFeatureName,
        searchElementFromElementsOfArray,
        roundToKg
    } from "../../components/utils.js"
    import {navigate} from "svelte-routing";

    // Helpotetaan maksimiarvojen arviointia parilla kaavalla
    let weight = 100;
    let reps = 5;
    let lombardi = 0;
    let mcglothin = 0;
    let oconneletal = 0;
    let brzycki = 0; // Weight × (36 / (37 – number of reps))
    let lander = 0;
    let epley = 0;
    let avg = 0;

    let maxWeightsData = null;
    let maxLifts = {};
    let loadingMaxWeightsData = false;

    // Alustetaan vähä dataa
    onMount(async function () {
        if ($userData && $userData.id) {
            console.log("onMount");
        } else {
            // Koodatessa ja selaimen automaattisella päivityksellä käyttäjän tietoja ei haieta
            // Automaattisesti, joten tänne tullaan aivan liian usein. Siksi automatic redirect
            console.log("getData :: userData puuttuu");
            navigate('/c/home', {replace: false});
        }

        // HAetaan käyttäjän maksiminostot
        if ($userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('maksiminostot'), $userFeatures)) {
            getMaxWeights();
        }
        calc1RepMax();
    });

    async function getMaxWeights() {
        loadingMaxWeightsData = true;
        const response = GET("/c/getMaxWeights");
        const data = await response;
        if (data) {
            maxWeightsData = data;
            loadingMaxWeightsData = false;

            // Liikkeitä ei ole loputtomasti, joten käydään ne läpi ja otetaan niistä maksimi
            maxWeightsData.forEach(
                function (currentValue, index, arr) {
                    switch (currentValue.exercise) {
                        case "backsquat":
                            maxLifts.maxBackSquat = currentValue.weight;
                            break;
                        case "frontsquat":
                            maxLifts.maxFrontSquat = currentValue.weight;
                            break;
                        case "deadlift":
                            maxLifts.maxDeadlift = currentValue.weight;
                            break;
                        case "bench":
                            maxLifts.maxBench = currentValue.weight;
                            break;
                        case "overheadpress":
                            maxLifts.maxOverheadPress = currentValue.weight;
                            break;
                        case "barbellrow":
                            maxLifts.maxBarbellRow = currentValue.weight;
                            break;
                        case "lateralraise":
                            maxLifts.maxLateralRaise = currentValue.weight;
                            break;
                        case "bicepcurl":
                            maxLifts.maxBicepCurl = currentValue.weight;
                            break;
                        case "pullup":
                            maxLifts.maxPullUp = currentValue.weight;
                            break;
                        case "clean":
                            maxLifts.maxClean = currentValue.weight;
                            break;
                        case "snatch":
                            maxLifts.maxSnatch = currentValue.weight;
                            break;
                        default:
                        // Ei tehdä mitään
                    }
                }
            )
        }
    }

    async function saveMaxWeights() {
        const response = POST("/c/saveMaxWeights", JSON.stringify(maxLifts));
        const data = await response;
        if (data) {
            flashSuccessMessage.set("Maksimitulokset tallennettu.");
        }
    }

    // Formulas taken from https://en.wikipedia.org/wiki/One-repetition_maximum
    function calc1RepMax() {
        if (weight && reps) {
            // Lombardi
            lombardi = weight * Math.pow(reps, 0.10);
            // McGlothin
            mcglothin = (100 * weight) / (101.3 - (2.67123 * reps));

            // O'Conner et al.
            oconneletal = weight * (1 + (reps / 40));
            // Mayhew et al.
            //mayhewetal = (100 * weight) / (52.2 + (Math.pow((Math.E * (41.9)), -0.055 * reps))); - en saa tehtyä tätä kaavaa
            // Lander
            lander = (100 * weight) / (101.3 - 2.67123 * reps);
            // Epley
            epley = weight * (1 + 0.0333 * reps);
            // Brzycki
            brzycki = weight * (36 / (37 - reps));

            avg = (lombardi + mcglothin + oconneletal + lander + epley) / 5;
        }
    }
</script>
<div class="page">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <h4 class="card-title">Aseta liikkeille yhden toiston maksimitulos.</h4>
                <p>Voimme laskea hyvin tarkasti, että millä painolla mikäkin treeni tulee tehdä, kun
                    lisäät omat maksimituloksesi tähän ylös. Mikäli et tiedä tulosta, laske alla olevalla
                    lomakkeella arvio maksimituloksestasi.
                    Voit tarkentaa lukuja myöhemmin.</p>

            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <!-- Maksimivoimakortti -- mahdollisuus näyttää treeneissä oikeat painot -->
                <div class="card" style="width: 100%;">
                    <div class="card-body">
                        <label for="backsquat">Takakyykky: </label>
                        <input size="6" maxlength="3" type="number" id="backsquat" bind:value={maxLifts.maxBackSquat}/>
                        <br/>
                        <label for="frontsquat">Etukyykky: </label>
                        <input size="6" maxlength="3" type="number" id="frontsquat" bind:value={maxLifts.maxFrontSquat}/>
                        <br/>
                        <label for="deadlift">Maastaveto: </label>
                        <input size="6" maxlength="3" type="number" id="deadlift" bind:value={maxLifts.maxDeadlift}/>
                        <br/>
                        <label for="bench">Penkkipunnerrus: </label>
                        <input size="6" maxlength="3" type="number" id="bench" bind:value={maxLifts.maxBench}/>

                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <!-- Maksimivoimakortti -- mahdollisuus näyttää treeneissä oikeat painot -->
                <div class="card" style="width: 100%;">
                    <div class="card-body">
                        <label for="overheadPress">Pystypunnerus: </label>
                        <input size="6" maxlength="3" type="number" id="overheadPress" bind:value={maxLifts.maxOverheadPress}/>
                        <br/>
                        <label for="barbellRow">Kulmasoutu: </label>
                        <input size="6" maxlength="3" type="number" id="barbellRow" bind:value={maxLifts.maxBarbellRow}/>
                        <br/>

                        <label for="bicepCurl">Hauiskääntö: </label>
                        <input size="6" maxlength="3" type="number" id="bicepCurl" bind:value={maxLifts.maxBicepCurl}/>
                        <br/>
                        <label for="pullUp">Leuka: </label>
                        <input size="6" maxlength="3" type="number" id="pullUp" bind:value={maxLifts.maxPullUp}/>
                        </div>
                </div>
            </div>
            <div class="col-md-4">
                <!-- Maksimivoimakortti -- mahdollisuus näyttää treeneissä oikeat painot -->
                <div class="card" style="width: 100%;">
                    <div class="card-body">
                        <label for="lateralRaise">Vipunosto: </label>
                        <input size="6" maxlength="3" type="number" id="lateralRaise" bind:value={maxLifts.maxLateralRaise}/>
                        <br/>
                        <label for="clean">Rinnalleveto: </label>
                        <input size="6" maxlength="3" type="number" id="clean" bind:value={maxLifts.maxClean}/>
                        <br/>
                        <label for="snatch">Tempaus: </label>
                        <input size="6" maxlength="3" type="number" id="snatch" bind:value={maxLifts.maxSnatch}/>
                        <br/>

                        <button on:click|preventDefault={saveMaxWeights} class="btn btn-primary">Tallenna</button>
                    </div>
                </div>
            </div>
        </div>
        {#if loadingMaxWeightsData}
            Haetaan tietoja ...
        {/if}
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <h2>Laske yhden toiston maksimi</h2>
                <p>Voit laskea yhden toiston maksimin, jos tiedät painon ja toistomäärän maksiminostosta. Esim. jos
                    tiedät, että olet kyykännyt sadalla kilolla viisi kertaa, voit syöttää luvut lomakkeeseen.</p>
                <p>Ykkösmaksimin laskemiseksi maailmasta löytyy monenlaisia kaavoja. Tähän otettu useita. Voit hyödyntää
                    laskurin tarjoamaa keskiarvoa tai hyödyntää sellaista lukemaa, joka tuntuu sinusta oikeimmalta.</p>
                <div class="form-group">
                    <label for="rm1squat">Paino (kg)</label>
                    <input maxlength="3" id="rm1squat" bind:value={weight}>kg
                </div>
                <div class="form-group">
                    <label for="reps">Toistomäärä</label>
                    <select id="reps" bind:value={reps}>
                        {#each Array(10) as _, i}
                            <option value="{i+1}">{i + 1}</option>
                        {/each}
                    </select>
                </div>
                <button on:click={calc1RepMax}>Laske maksimi</button>
                <div class="row">
                    <div class="col-12">
                        <table class="table table-striped table-sm">
                            <thead>
                            <tr>
                                <th>Yhden toiston maksimi</th>
                                <th>Keskiarvo</th>
                                <th>Lombardi</th>
                                <th>McGlothin</th>
                                <th>O'Conner et al.</th>
                                <th>Lander</th>
                                <th>Epley</th>
                                <th>Brzycki</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>1</td>
                                <td>{roundToKg(avg)}</td>
                                <td>{roundToKg(lombardi)}</td>
                                <td>{roundToKg(mcglothin)}</td>
                                <td>{roundToKg(oconneletal)}</td>
                                <td>{roundToKg(lander)}</td>
                                <td>{roundToKg(epley)}</td>
                                <td>{roundToKg(brzycki)}</td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
